import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ErrorIcon } from './ErrorIcon';
import { GridContainer } from './GridContainer';
import { useTranslation } from 'react-i18next';

type Props = {
  message?: string | JSX.Element;
};

export const Error: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <GridContainer>
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        <ErrorIcon titleAccess={t('components.error.error', 'Error')} />
        {message && <Typography variant="subtitle2">{message}</Typography>}
      </Grid>
    </GridContainer>
  );
};
